module.exports = __webpack_public_path__ + "media/1_3-42.171efcc3.mp3";